import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import InsetList from './InsetList';
import ClientProvider from './client';
export default createDemo(import.meta.url, InsetList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/inset/InsetList.tsx",
    "fileName": "InsetList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport StarIcon from '@mui/icons-material/Star';\n\nexport default function InsetList() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <List\n      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}\n      aria-label=\"contacts\"\n    >\n      <ListItem disablePadding>\n        <ListItemButton>\n          <ListItemIcon>\n            <StarIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Chelsea Otakan\" />\n        </ListItemButton>\n      </ListItem>\n      <ListItem disablePadding>\n        <ListItemButton>\n          <ListItemText inset primary=\"Eric Hoffman\" />\n        </ListItemButton>\n      </ListItem>\n    </List>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport StarIcon from '@mui/icons-material/Star';\n\nexport default function InsetList() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <List\n      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}\n      aria-label=\"contacts\"\n    >\n      <ListItem disablePadding>\n        <ListItemButton>\n          <ListItemIcon>\n            <StarIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Chelsea Otakan\" />\n        </ListItemButton>\n      </ListItem>\n      <ListItem disablePadding>\n        <ListItemButton>\n          <ListItemText inset primary=\"Eric Hoffman\" />\n        </ListItemButton>\n      </ListItem>\n    </List>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 29,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/icons-material/Star"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
